import SidebarItems from "./SidebarItems";

function SidebarLarge() {
  return (
    <div className="border border-1 rounded px-2" style={{ width: 250 }}>
      <SidebarItems />
    </div>
  );
}

export default SidebarLarge;
